import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeliveryResponse } from '../models/delivery-response.model';
import { DeliveryRequest, PagedServices } from '../models/delivery-request.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeliveryRequestService {
  private url = `${environment.apiUrl}/services`;

  constructor(private http: HttpClient) {}

  getDeliveryRequests(): Observable<DeliveryResponse[]> {
    return this.http.get<DeliveryResponse[]>(this.url);
  }

  getServices(page: number, limit: number, query? : string): Observable<PagedServices> {
    let queryString = `page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    return this.http.get<PagedServices>(
      `${environment.apiUrl}/services?${queryString}`
    );
   
  }

  createService(service: DeliveryRequest): Observable<DeliveryRequest> {
    const url = `${environment.apiUrl}/services`;
    return this.http.post<DeliveryRequest>(url, service);
  }

  editService(id: number, service: DeliveryRequest): Observable<DeliveryRequest> {
    const url = `${environment.apiUrl}/services/${id}`;
    return this.http.put<DeliveryRequest>(url, service);
  }
  
  searchServices(page: number, limit: number, query: string): Observable<PagedServices> {
    return this.http.get<PagedServices>(
      `${environment.apiUrl}/services?page=${page}&limit=${limit}&search=${query}`
    );
  }

  postDeliveryRequest(request: DeliveryRequest): Observable<DeliveryRequest> {
    return this.http.post<DeliveryRequest>(this.url, request);
  }

  assignDeliveryRequest(service_id: number, rider_id: number): Observable<DeliveryRequest> {
    const url = `${environment.apiUrl}/service/assign`;
    const body = { service_id, rider_id };
    return this.http.post<DeliveryRequest>(url, body);
  }
}
